module.exports = __webpack_public_path__ + "caedb9129bf6bd63ff4081a0ba91e113.svg";